import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { SprayEventUuid } from 'services/sprayEvents/types';
import { AppState } from 'services/types';
import DeleteEventModalMessage from 'components/DeleteEventModalMessage';
import { makeSelectSelectedSprayEventsDates } from './selectors';

export interface OwnProps {
    uuids: SprayEventUuid[];
}

interface ConnectedProps {
    dates: string[];
}

type Props = ConnectedProps & OwnProps;

export class DeleteSprayEventModalMessageComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { dates, uuids } = this.props;

        return (
            <DeleteEventModalMessage
                uuids={uuids}
                dates={dates}
                eventName="Spray Event"
                eventPluralName="Spray Events"
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    dates: makeSelectSelectedSprayEventsDates()
});

export default connect(mapStateToProps)(DeleteSprayEventModalMessageComponent);
